import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ListSurveys } from "Features/Survey";

function StorageCostList () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle
                title={t("pages.storageCosts")}
            />
            <ListSurveys surveyRef="storagecost" />
        </Container>
    );
}

export default StorageCostList;